var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLimitsMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25 5.5H21.75V9.25H9.25V9.875H8V9.25H4.25V5.5H8V4.875H9.25V5.5ZM5.5 6.75V8H8V6.75H5.5ZM9.25 8H20.5V6.75H9.25V8ZM21.75 11.125H18V10.5H16.75V11.125H4.25V14.875H16.75V15.5H18V14.875H21.75V11.125ZM5.5 13.625V12.375H16.75V13.625H5.5ZM20.5 13.625H18V12.375H20.5V13.625ZM21.75 16.75H13V16.125H11.75V16.75H4.25V20.5H11.75V21.125H13V20.5H21.75V16.75ZM5.5 19.25V18H11.75V19.25H5.5ZM13 19.25V18H20.5V19.25H13Z",
    fill: "#8C8C8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLimitsMenuIcon);
export default __webpack_public_path__ + "static/media/limits-menu-icon.c575590b7f46a4623ffdb6c514d87b12.svg";
export { ForwardRef as ReactComponent };